import React from 'react';
import { observer } from 'mobx-react-lite';
import { generalStore } from '../../store';
import { FiAlertTriangle } from 'react-icons/fi';

const ServerError: React.FC = observer(() => {
  if (!generalStore.isServerError) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl p-6 mx-8 max-w-sm w-full flex flex-col items-center gap-4 shadow-xl">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
          <FiAlertTriangle className="w-8 h-8 text-red-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Server Error</h3>
        <p className="text-sm text-gray-500 text-center">
          {generalStore.serverErrorMessage || 'Something went wrong. Please try again later.'}
        </p>
        <button
          onClick={() => generalStore.setServerError(false)}
          className="w-full py-3 bg-[#39377F] text-white rounded-xl font-semibold text-sm active:opacity-80 transition-opacity"
        >
          Try Again
        </button>
      </div>
    </div>
  );
});

export default ServerError;
